import { forwardRef, Ref } from 'react';

import { Kit } from '@repo/types';
import { stringifyDaysOld } from 'helpers';
import { InsightMetric } from 'types/Insights';

import { Typography } from '@repo/ui';
import LogoSvg from 'assets/images/logos/logo-full.svg';
import MaturationIndexGraph from './MaturationIndexGraph';

import styles from './MaturationIndexShareImage.module.css';

const MaturationIndexShareImage = forwardRef(function MaturationIndexShareImage(
  {
    kit,
    subMetric,
    name,
  }: { kit: Kit; subMetric: InsightMetric; name: string },
  ref,
) {
  return (
    <div
      className={styles.cardContainer}
      style={{ width: 362, height: 362 }}
      ref={ref as Ref<HTMLDivElement> | null}
    >
      {' '}
      <div className='dark-grey mb-2'>
        <Typography variant='heading-m'>{`${name}'s gut looks like that of a`}</Typography>
      </div>
      <div className=''>
        <Typography
          variant={'heading-2xl'}
          className={subMetric.evaluation_color}
          serif
        >
          {stringifyDaysOld(subMetric.user_value)}
        </Typography>
      </div>
      <div className={styles.chartContainer}>
        <MaturationIndexGraph
          kit={kit}
          subMetric={subMetric}
          showXAxisLabel={false}
          disableAnimations={true}
          onlyCurrentKit={true}
        />
      </div>
      <div className={styles.logoContainer}>
        <img src={LogoSvg} />
      </div>
    </div>
  );
});

export default MaturationIndexShareImage;
